// extracted by mini-css-extract-plugin
export default {"step":"Step__step___fw5lm","stepName":"Step__stepName___RD1Wj","image":"Step__image___P9vVB","title":"Step__title___h3Ghw","descr":"Step__descr___omveb"};